module.exports = __webpack_public_path__ + "img/gl6.0d28df88.jpg";